import React, { FC } from 'react';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
import { OrderItemProduct, OrderRefundItem } from '../../../..';
import { Order, OrderItem } from '../../../../../../shared/orders/model';
import { IconColor } from '../../../../../components';
import { MaterialIconText } from '../../../../../components/MaterialIconText';
import { TranslationKey, useTranslation } from '../../../../../translations';
import { sumBy } from '../../../../../utils';

interface OrderInfoItemGroupProps {
  readonly title: TranslationKey;
  readonly order: Order;
  readonly orderItems: OrderItem[];
  readonly icon: string;
  readonly iconColor?: IconColor;
  readonly addButton?: () => void;
  readonly onUpdate?: () => void;
}

export const OrderInfoItemGroup: FC<OrderInfoItemGroupProps> = ({
  title,
  orderItems,
  icon,
  iconColor,
  order,
  addButton,
  onUpdate,
}) => {
  const { ts } = useTranslation();
  const totalCount = orderItems.length + sumBy(order.refunds, (t) => t.items.length);

  if (orderItems.length === 0 && !addButton) {
    return null;
  }

  return (
    <Card className="mb-10">
      <CardHeader>
        {addButton && (
          <Button
            color="primary"
            id="addProduct"
            onClick={addButton}
            style={{ float: 'right', padding: '0px 5px' }}
          >
            +
          </Button>
        )}
        <MaterialIconText name={icon} type={iconColor}>
          {ts(title)} &mdash; {totalCount} {ts('common.items')}
        </MaterialIconText>
      </CardHeader>
      <CardBody>
        {orderItems.map((item) => (
          <OrderItemProduct
            adminControls
            cashierUI
            item={item}
            key={item.id}
            onUpdate={onUpdate}
            order={order}
            readOnly={!addButton}
          />
        ))}
        {order.refunds.map((refund) => {
          return <OrderRefundItem key={refund.id} orderItems={orderItems} refund={refund} />;
        })}
      </CardBody>
    </Card>
  );
};
